import React from "react";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { ImgContext } from "../Context/ImageCon";
import axios from "../axios";
function Pdfs() {
  const [pdf, setPdf] = React.useState("");
  // eslint-disable-next-line no-unused-vars
  const [img, setImg] = React.useContext(ImgContext);

  let handleClick = (e) => {
    console.log(e.target.files[0]);
    setPdf(e.target.files[0]);
  };

  let handleQR = () => {
    axios
      .post(
        "pdf/",
        {
          name: pdf.name,
          uploads: pdf,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setImg(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="section">
      {localStorage.getItem("access_token") ? (
        <div>
          <input
            accept="application/pdf"
            className="input-file"
            style={{ display: "none" }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={handleClick}
          />
          <label htmlFor="raised-button-file">
            <Box className="UploadBox">
              <UploadFile />
            </Box>
          </label>
        </div>
      ) : (
        "  Must be logged in to upload a pdf"
      )}
      {pdf ? pdf.name : null}

      {pdf ? (
        <Button
          onClick={handleQR}
          style={{ marginTop: "12%", marginLeft: "12%" }}
          variant="contained"
          color="primary"
        >
          Make QR
        </Button>
      ) : null}
    </div>
  );
}

export default Pdfs;
